<template>
  <div class="modal-inner-area sp-area row">
              <div class="col-lg-5">
                <div class="sp-img_area">
                  <div class="sp-img_slider slick-img-slider uren-slick-slider" data-slick-options='{
                                    "slidesToShow": 1,
                                    "arrows": false,
                                    "fade": true,
                                    "draggable": false,
                                    "swipe": false,
                                    "asNavFor": ".sp-img_slider-nav"
                                    }'>
                    <div class="single-slide red">
                      <img src="/images/product/large-size/1.jpg" alt="Uren's Product Image">
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class="col-xl-7 col-lg-6">
                <div class="sp-content">
                  <div class="sp-heading">
                    <h5><a href="#">{{product.name}}</a></h5>
                  </div>
                  <div class="rating-box">
                    <ul>
                      <li><i class="ion-android-star"></i></li>
                      <li><i class="ion-android-star"></i></li>
                      <li><i class="ion-android-star"></i></li>
                      <li class="silver-color"><i class="ion-android-star"></i></li>
                      <li class="silver-color"><i class="ion-android-star"></i></li>
                    </ul>
                  </div>
                  <div class="price-box">
                    <span class="new-price new-price-2">{{ product.price }}</span>
                    <!-- <span class="old-price">$241.00</span> -->
                  </div>
                  <div class="sp-essential_stuff">
                    <ul>
                      <li>Brands <a href="javascript:void(0)">{{product.brand}}</a></li>
                      <li>Availability: <a href="javascript:void(0)">{{ product.available ? 'In Stock' : 'Not Available Now'}}</a></li>
                    </ul>
                  </div>
                  <div class="quantity">
                    <label>Quantity</label>
                    <div class="cart-plus-minus">
                      <input v-model="order_quantity" class="cart-plus-minus-box" value="1" type="text">
                      <div class="dec qtybutton"><i class="fa fa-angle-down"></i></div>
                      <div class="inc qtybutton"><i class="fa fa-angle-up"></i></div>
                    </div>
                  </div>
                  <div class="uren-group_btn">
                    <ul>
                      <li><router-link to="/mini-cart" class="add-to_cart">Add To Cart</router-link></li>
                    </ul>
                  </div>
                  
                </div>
              </div>
            </div>
</template>

<script>
export default {
  name: "QuickView",
  data() {
    return {
      product: {
        name: "Product 1",
        reference: "P0Y-STANLEY",
        price: 150.25,
        available: true,
        brand: 'Stanley',
        img: 'images/product/large-size/1.jpg',
        desc: `Voluptatum, minus? Optio molestias voluptates aspernatur laborum ratione minima, natus
                          eaque nemo rem quisquam, suscipit architecto saepe. Debitis omnis labore laborum consectetur,
                          quas, esse voluptates minus aliquam modi nesciunt earum! Vero rerum molestiae corporis libero
                          repellat doloremque quae sapiente ratione maiores qui aliquam, sunt obcaecati! Iure nisi
                          doloremque numquam delectus.`

      },
      order_quantity: 1,
    }
    
  }
}
</script>

<style>

</style>
